import ActionButton from "./abstract/ActionButton";
import CommonJsStorage from "./CommonJsStorage";
import CompareButton from "./CompareButton";
import Counter from "./Counter";
import FavoriteButton from "./FavoriteButton";
import ActionButtons from "./ActionButtons";
import PopupHint from "./popup/PopupHint";

const axios      = require('axios');
const microModal = require('micromodal');

let commonStorage    = new CommonJsStorage(window['commonStore'] || {});
let compareCounter   = new Counter('.js-header-compare', commonStorage.get('compare'));
microModal.init({}); // see MicroModal configuration here https://micromodal.now.sh/#configuration

let ApplicationState = {
    resizeHandlersList: [],
    axios: axios.create({
        timeout: 5000,
        headers: {
            HTTP_X_REQUESTED_WITH: 'XMLHttpRequest', // ajax marker
        }
    }),
    popupHint: new PopupHint('#popup-hint'),
    commonStorage: commonStorage,
    modal: microModal,
    compareCounter: compareCounter,
}

export default ApplicationState;